export const baseUri = `feature-scopes`;
